import * as api from '../../../clients/qschecks';

import {Action} from '@ngrx/store';

export const GET_PRUEFPLAN_ANTWORTEN_ADMIN = '[QschecksModul] GetPruefplanAntwortenAdmin laden';
export const GET_PRUEFPLAN_ANTWORTEN_ADMIN_AUSFUEHREN = '[QschecksModul] GetPruefplanAntwortenAdmin ausführen';
export const GET_PRUEFPLAN_ANTWORTEN_ADMIN_ERFOLGREICH = '[QschecksModul] GetPruefplanAntwortenAdmin laden erfolgreich';
export const GET_PRUEFPLAN_ANTWORTEN_ADMIN_FEHLER = '[QschecksModul] GetPruefplanAntwortenAdmin Ladefehler';
export const GET_PRUEFPLAN_ANTWORTEN_ADMIN_NICHT_AUSGEFUEHRT = '[QschecksModul] GetPruefplanAntwortenAdmin nicht ausgeführt (evtl. Offline)';


export class GetPruefplanAntwortenAdminAction implements Action {
    readonly type = GET_PRUEFPLAN_ANTWORTEN_ADMIN;
        constructor( public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanAntwortenAdminAusfuehrenAction implements Action {
    readonly type = GET_PRUEFPLAN_ANTWORTEN_ADMIN_AUSFUEHREN;
        constructor( public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanAntwortenAdminErfolgreichAction implements Action {
    readonly type = GET_PRUEFPLAN_ANTWORTEN_ADMIN_ERFOLGREICH;
        constructor(public payload: Array<api.Pruefantwort>,  public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanAntwortenAdminFehlerAction implements Action {
    readonly type = GET_PRUEFPLAN_ANTWORTEN_ADMIN_FEHLER;
        constructor(public payload: any,  public pruefplan_id:string , public optPayload: any = null) {}
    }
export class GetPruefplanAntwortenAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_PRUEFPLAN_ANTWORTEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type QschecksQueryPruefplanAntwortenAdminActions =
    GetPruefplanAntwortenAdminAction
    | GetPruefplanAntwortenAdminAusfuehrenAction
    | GetPruefplanAntwortenAdminErfolgreichAction
    | GetPruefplanAntwortenAdminFehlerAction
    | GetPruefplanAntwortenAdminNichtAusgefuehrtAction
    ;
